import {useState} from 'react';
import LoginForm from '../components/LoginForm';
import WholesaleBg from '../assets/loginbackground.png'
import RetailBg from '../assets/Retailbg.png'

const Login = () => {
    const [activeTab, setActiveTab] = useState('wholesale');

    const backgroundImage = activeTab === 'wholesale' ? WholesaleBg : RetailBg;
  
    return (
        <div>
            {/* <HomeNav /> */}
            <div className=' flex justify-end items-center bg-gray-100 h-screen w-full bg-cover bg-top 'style={{ backgroundImage: `url(${backgroundImage})` }}>
                <LoginForm activeTab={activeTab} setActiveTab={setActiveTab}/>
            </div>
        </div>
    );
}

export default Login;
